export default "__VITE_ASSET__37ccfde9__"